import http from "./http";

const apiEndpoint = process.env.REACT_APP_BASE_URL + "/api/WorkPlace";

export function getWorkPlaces() {
  return http.post(`${apiEndpoint}/GetCurrent`);
}

